/**
 * Typesafe access of Type property names
 * Yields an error if applied property string doesn't exist on the Type
 * Example usage:
 * `const somePropName = nameof<SomeType>('someProp');`
 * @param key
 */
export function nameof<T>(key: keyof T): keyof T {
  return key;
}

export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

export function isNumber(value: unknown): value is number {
  return typeof value === 'number';
}

export function isDate(value: unknown): value is Date {
  return value instanceof Date && !isNaN(value.valueOf());
}

// Remove readonly
export type Mutable<T> = { -readonly [P in keyof T]: T[P] };
